import { SBCRewardType } from "@/api/privateRequests/sbcs/getSbcSets";
import { useTranslation } from "@repo/shared/i18n";

/**
 * Whether the reward can be sold on, as a chip beside the "Reward" label.
 *
 * Renders nothing where the question does not apply: a player reward carries
 * its role and rating instead, and cosmetics and tokens are never traded.
 */
export const TradeableChip = ({
  rewardType,
  untradeable,
}: {
  rewardType?: SBCRewardType["type"];
  untradeable?: boolean;
}) => {
  const { t } = useTranslation("sbcs");

  if (
    rewardType === "player" ||
    rewardType === "cosmetic-evo" ||
    rewardType === "event_token_2"
  ) {
    return null;
  }

  return (
    /* w-fit and self-start: as a flex item in a column it would otherwise
       be stretched to the width of the description beside it. */
    <span className="w-fit self-start rounded-sm border border-edge-strong bg-surface px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.1em] text-foreground-muted">
      {untradeable ? t("set.untradeable") : t("set.tradeable")}
    </span>
  );
};
